<mat-toolbar>
  <span>{{ dokumentversjon.pdfFilnavn }}</span>
  <button mat-icon-button (click)="lukk()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
<mat-dialog-content>
  <dokument-vis-pdf-iframe [dokumentversjon]="dokumentversjon"/>
</mat-dialog-content>
